import MedicalService from "../../../service/medical"

const Action = {
    GET_MEDICAL: "[ ADMIN_MEDICAL ] GET_MEDICAL",
    GET_MEDICALS: "[ ADMIN_MEDICAL ] GET_MEDICALS",
    UPDATE_MEDICAL:"[ ADMIN_MEDICAL ] UPDATE_MEDICAL",

    GET_MEDICAL_WORK_EVENTS: '[ ADMIN_MEDICAL ] GET_MEDICAL_WORK_EVENTS',
    PUT_MEDICAL_WORK_EVENTS: '[ ADMIN_MEDICAL ] PUT_MEDICAL_WORK_EVENTS',
}

const ActionCreator = {
    getMedical(medicalId) {
        return async (dispatch) => {
            try {
                const medical = await MedicalService.findById(medicalId)
                dispatch({type: Action.GET_MEDICAL, medical})
                return medical
            } catch (error) {
                throw dispatch({error})
            }
        };
    },
    getMedicals() {
        return async (dispatch) => {
            try {
                const medicals = await MedicalService.list()
                dispatch({type: Action.GET_MEDICALS, medicals})
                return medicals
            } catch (error) {
                throw dispatch({error})
            }
        }
    },
    updateMedical({medical}) {
        return async (dispatch) => {
            try {
                const updatedMedical = await MedicalService.updateMedical({medical});
                dispatch({type: Action.UPDATE_MEDICAL, updatedMedical});
                return updatedMedical;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },

    getWorkEventsByMonth({ id, month }) {
        return async dispatch => {
            try {
                const workEvents = await MedicalService.getWorkEventsByMonth({ id, month })
                dispatch({ type: Action.GET_MEDICAL_WORK_EVENTS, workEvents })
                return workEvents
            } catch (error) {
                throw dispatch({ error })
            }
        }
    },
    putWorkEventsByMonth({ id, month, workEvents }) {
        return async dispatch => {
            try {
                const _workEvents = await MedicalService.putWorkEventsByMonth({ id, month, workEvents })
                dispatch({ type: Action.PUT_MEDICAL_WORK_EVENTS, workEvents: _workEvents })
                return _workEvents
            } catch (error) {
                throw dispatch({ error })
            }
        }
    }
}

const initialState = {
    medicals: [],
    medical: {},
    workEvents: [],
}

const Reducer = function (state = initialState, action) {
    switch (action.type) {
        case Action.GET_MEDICAL:
            return {
                ...state,
                medical: action.medical
            }
        case Action.GET_MEDICALS:
            return {
                ...state,
                medicals: action.medicals
            }
        case Action.UPDATE_MEDICAL:
            return {
                ...state,
                medical: action.updatedMedical
            }
        case Action.GET_MEDICAL_WORK_EVENTS:
        case Action.PUT_MEDICAL_WORK_EVENTS:
            return {
                ...state,
                workEvents: action.workEvents,
            }
        default: {
            return state
        }
    }
}

export default {Action, ActionCreator, Reducer}



// WEBPACK FOOTER //
// ./src/store/actionreducers/adminMedical/medical.js